(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  class CollectionResults {
    constructor(section) {
      this.section = section;
      this.results = section.querySelector('[data-collection-results]');
      this.observer = null;
      this.loading = false;

      section.addEventListener('click', (event) => {
        const link = event.target.closest('.collection__filter-tab');
        if (!link) return;
        event.preventDefault();
        this.fetchResults(link.href);
      });

      // Delegated on the (never-replaced) section, not bound directly to
      // the <select> - fetchResults() below swaps out the whole results
      // container, including the sort form, on every successful sort/filter
      // change, which would otherwise detach a directly-bound listener
      // after the first change.
      section.addEventListener('change', (event) => {
        const sortSelect = event.target.closest('[data-collection-sort-select]');
        if (!sortSelect) return;
        const form = sortSelect.closest('form');
        const params = new URLSearchParams(new FormData(form));
        this.fetchResults(`${form.action}?${params.toString()}`);
      });

      this.observeSentinel();
    }

    fetchResults(url, { append = false } = {}) {
      if (this.loading) return;
      this.loading = true;

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const fresh = html.querySelector('[data-collection-results]');
          if (!fresh) return;

          if (append) {
            const freshGrid = fresh.querySelector('[data-collection-grid]');
            const currentGrid = this.results.querySelector('[data-collection-grid]');
            if (freshGrid && currentGrid) currentGrid.append(...freshGrid.children);

            const freshSentinel = fresh.querySelector('[data-collection-sentinel]');
            const currentSentinel = this.results.querySelector('[data-collection-sentinel]');
            if (freshSentinel && currentSentinel) {
              currentSentinel.dataset.nextUrl = freshSentinel.dataset.nextUrl;
            } else if (currentSentinel) {
              currentSentinel.remove();
            }
          } else {
            this.results.replaceWith(fresh);
            this.results = fresh;
            window.history.pushState({}, '', url);
            this.observeSentinel();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }

    observeSentinel() {
      if (this.observer) this.observer.disconnect();

      const sentinel = this.results.querySelector('[data-collection-sentinel]');
      if (!sentinel) return;

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) this.fetchResults(sentinel.dataset.nextUrl, { append: true });
        });
      });

      this.observer.observe(sentinel);
    }
  }

  document.querySelectorAll('[data-collection-section]').forEach((section) => new CollectionResults(section));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["complete-the-look"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-recommendations]').forEach((section) => {
    const url = section.dataset.url;
    if (!url) return;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const fresh = html.querySelector('.complete-the-look');

        if (fresh && fresh.querySelector('.product-card')) {
          section.replaceWith(fresh);
        } else {
          section.remove();
        }
      })
      .catch(() => section.remove());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-popup"]) return;
  try {
    
  class EmailPopup {
    constructor(dialog) {
      this.dialog = dialog;
      this.storageKey = dialog.dataset.storageKey;
      this.designMode = Boolean(window.Shopify && window.Shopify.designMode);
      this.reuseAfterDays = Number(dialog.dataset.reuseAfterDays) || 0;

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog || event.target.closest('[data-email-popup-close]')) dialog.close();
      });
      dialog.addEventListener('close', () => this.remember());
      dialog.querySelector('form')?.addEventListener('submit', () => this.remember());

      /*
       * In the theme editor the popup is driven by the merchant, not the
       * timer: it opens when the section is selected in the sidebar and
       * closes when they move on, so it never blocks the rest of the
       * page. Closing it here must not write the suppression key
       * either - see remember().
       */
      if (this.designMode) {
        const sectionId = dialog.dataset.sectionId;

        document.addEventListener('shopify:section:select', (event) => {
          if (event.detail.sectionId === sectionId) this.open();
        });

        document.addEventListener('shopify:section:deselect', (event) => {
          if (event.detail.sectionId === sectionId) dialog.close();
        });

        return;
      }

      // Shopify redirects back with ?customer_posted=true after a successful
      // signup - reopen so the confirmation is visible, and never again after.
      if (dialog.querySelector('[data-email-popup-success]')) {
        this.open();
        return;
      }

      if (this.suppressed()) return;

      this.timer = setTimeout(() => this.open(), Number(dialog.dataset.delay) * 1000);
    }

    open() {
      // The editor re-renders the section on every settings change, so an
      // older instance's listeners can still fire against a detached dialog.
      if (this.dialog.isConnected && !this.dialog.open) this.dialog.showModal();
    }

    suppressed() {
      try {
        const until = Number(localStorage.getItem(this.storageKey));
        return Boolean(until) && Date.now() < until;
      } catch (error) {
        // Storage blocked (private mode, cookie settings): show it anyway.
        return false;
      }
    }

    remember() {
      if (this.designMode) return;

      try {
        localStorage.setItem(this.storageKey, String(Date.now() + this.reuseAfterDays * 86400000));
      } catch (error) {
        // Nothing to do - the popup will simply show again next visit.
      }
    }
  }

  const emailPopups = Array.from(document.querySelectorAll('[data-email-popup]')).map(
    (dialog) => new EmailPopup(dialog)
  );

  document.addEventListener('click', (event) => {
    if (!event.target.closest('a[href="#open-newsletter-popup"]')) return;
    event.preventDefault();
    emailPopups.forEach((popup) => popup.open());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.getElementById('footer-localization-form')?.addEventListener('change', (event) => {
    event.currentTarget.submit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const dialog = document.getElementById('header-menu-dialog');
    if (!dialog) return;

    if (event.target.closest('[aria-controls="header-menu-dialog"]')) {
      dialog.showModal();
    } else if (event.target.closest('.header__menu-dialog-close') || event.target === dialog) {
      dialog.close();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductVariantPicker {
    constructor(form) {
      this.form = form;
      this.variants = JSON.parse(form.querySelector('[data-product-variants]').textContent);
      this.priceEl = document.querySelector('[data-product-price]');
      this.idInput = form.querySelector('[data-variant-id]');
      this.submitButton = form.querySelector('[data-add-to-cart]');
      this.buttonText = this.submitButton ? this.submitButton.querySelector('[data-button-text]') : null;
      this.preorderBox = form.querySelector('[data-preorder-box]');
      this.notifyBlocks = form.querySelector('[data-notify-blocks]');
      this.gallery = document.querySelector('[data-slider-track]');

      form.addEventListener('change', (event) => {
        if (event.target.matches('input[type="radio"]')) this.update(event.target);
      });

      this.updateAvailability();
    }

    getOptionFieldsets() {
      return Array.from(this.form.querySelectorAll('[data-option-position]')).sort(
        (a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
    }

    findVariant(options) {
      if (options.includes(null)) return null;
      return this.variants.find((variant) => variant.options.every((value, i) => value === options[i]));
    }

    hasMatchFor(fieldsets, options) {
      return this.variants.some((variant) => options.every((value, i) => value === null || variant.options[i] === value));
    }

    // The option matrix isn't guaranteed dense (e.g. a print color only
    // exists for some colors), so a choice that was valid a moment ago can
    // stop being one once another option changes. Rather than disabling
    // the newly-picked value's own options (which would trap the shopper -
    // they'd be unable to switch color at all once an incompatible ink
    // color was already selected), the *other*, now-conflicting
    // selections get cleared instead, and if that leaves only one
    // remaining valid choice for a field, it's auto-selected.
    clearConflictingSelections(fieldsets, changedInput) {
      const changedFieldset = changedInput.closest('[data-option-position]');

      fieldsets.forEach((fieldset) => {
        if (fieldset === changedFieldset) return;

        const checked = fieldset.querySelector('input:checked');
        if (!checked) return;

        const candidate = fieldsets.map((fs) => {
          if (fs === changedFieldset) return changedInput.value;
          if (fs === fieldset) return checked.value;
          return null;
        });

        if (!this.hasMatchFor(fieldsets, candidate)) checked.checked = false;
      });
    }

    autoSelectSoleRemainingValues(fieldsets) {
      const options = fieldsets.map((fieldset) => {
        const checked = fieldset.querySelector('input:checked');
        return checked ? checked.value : null;
      });

      fieldsets.forEach((fieldset, index) => {
        if (options[index]) return;

        const compatible = Array.from(fieldset.querySelectorAll('input[type="radio"]')).filter((input) => {
          const candidate = options.slice();
          candidate[index] = input.value;
          return this.hasMatchFor(fieldsets, candidate);
        });

        if (compatible.length === 1) {
          compatible[0].checked = true;
          options[index] = compatible[0].value;
        }
      });
    }

    // Grays out (but never disables - see clearConflictingSelections)
    // any value that wouldn't combine with the current selections into a
    // real variant, so the sparse matrix is visible before a shopper
    // clicks into a dead end.
 updateAvailability() {
  const fieldsets = this.getOptionFieldsets();
  const options = fieldsets.map((fieldset) => {
    const checked = fieldset.querySelector('input:checked');
    return checked ? checked.value : null;
  });

  fieldsets.forEach((fieldset, fieldsetIndex) => {
    fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
      const candidate = options.slice();
      candidate[fieldsetIndex] = input.value;

      const hasAvailableMatch = this.variants.some((variant) => {
        const matchesOptions = candidate.every(
          (value, i) => value === null || variant.options[i] === value
        );

        return matchesOptions && (variant.available || variant.is_preorder);
      });

      const label = input.closest('.swatch, .product-option-button');
      if (label) label.classList.toggle('is-unavailable', !hasAvailableMatch);
    });
  });
}

    update(changedInput) {
      const fieldsets = this.getOptionFieldsets();

      if (changedInput) this.clearConflictingSelections(fieldsets, changedInput);
      this.autoSelectSoleRemainingValues(fieldsets);

      fieldsets.forEach((fieldset) => {
        const checked = fieldset.querySelector('input:checked');
        const label = fieldset.querySelector('[data-selected-option]');
        if (label) label.textContent = checked ? checked.value : label.dataset.placeholder;
      });

      const options = fieldsets.map((fieldset) => {
        const checked = fieldset.querySelector('input:checked');
        return checked ? checked.value : null;
      });

      this.updateAvailability();

      const variant = this.findVariant(options);

      if (!variant) {
        if (this.submitButton) this.submitButton.disabled = true;
        // No resolved variant yet (incomplete selection) - there is
        // nothing to notify about, so don't leave a stale button up.
        if (this.notifyBlocks) this.notifyBlocks.classList.add('product-form__blocks--hidden');
        return;
      }

      if (this.idInput) this.idInput.value = variant.id;
      if (this.priceEl) this.priceEl.textContent = variant.price;

      // Keep ?variant= in sync so the URL stays shareable, and so app
      // blocks can follow the selection - the restock/notify-me app
      // reads this param and re-renders off a patched history call
      // rather than off any theme event we could dispatch.
      const url = new URL(window.location.href);
      if (url.searchParams.get('variant') !== String(variant.id)) {
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }

      if (variant.featured_media_index >= 0 && this.gallery) {
        const slide = this.gallery.children[variant.featured_media_index];
        if (slide) slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      }

      if (this.preorderBox) this.preorderBox.classList.toggle('preorder-box--hidden', !variant.is_preorder);

      if (this.notifyBlocks) {
        const soldOut = !variant.available && !variant.is_preorder;
        this.notifyBlocks.classList.toggle('product-form__blocks--hidden', !soldOut);
      }

      if (this.submitButton) this.submitButton.disabled = !variant.available;

      if (this.buttonText) {
        if (!variant.available) {
          this.buttonText.textContent = this.buttonText.dataset.soldOutLabel;
        } else if (variant.is_preorder) {
          this.buttonText.textContent = `${this.buttonText.dataset.preorderLabel} — ${variant.price}`;
        } else {
          this.buttonText.textContent = this.buttonText.dataset.addLabel;
        }
      }
    }
  }

  document.querySelectorAll('[data-product-form]').forEach((form) => new ProductVariantPicker(form));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-guide-dialog"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (!document.getElementById('size-guide-dialog')) {
      document.querySelectorAll('[data-size-guide-open]').forEach((trigger) => trigger.remove());
    }
  });

  document.addEventListener('click', (event) => {
    const dialog = document.getElementById('size-guide-dialog');
    if (!dialog) return;

    // Any trigger - the product form's own button, or a footer menu link
    // titled "Size Guide" (still a normal <a>, see snippets/footer-menu-
    // link.liquid) - carries this attribute. The <a> case needs its
    // default navigation stopped; a <button> has none to stop.
    const trigger = event.target.closest('[data-size-guide-open]');
    if (trigger) {
      event.preventDefault();
      dialog.showModal();
    } else if (event.target.closest('.size-guide-dialog__close') || event.target === dialog) {
      dialog.close();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
